export default {
    props: {
        tooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.background'
        }, 
        tooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.border.color'
        }, 
        tooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'tooltip.border.width'
        }, 
        tooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.color'
        }, 
        tooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.font'
        }, 
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        }, 
        tooltipPadding: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'tooltip.padding'
        }, 
        tooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'tooltip.template'
        }, 
        tooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.visible'
        }, 
        tooltipShared: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.shared'
        }, 
        tooltipSharedTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.sharedTemplate'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/Tooltip.js